
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/key-club",
      function () {
        return require("private-next-pages/key-club.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/key-club"])
      });
    }
  